import { useState } from "react";
import PricingHero from "./components/PricingHero";
import PricingCards from "./components/PricingCards";
import PricingComparison from "./components/PricingComparison";
import PricingFAQ from "./components/PricingFAQ";
import PricingCTA from "./components/PricingCTA";
import FeaturesNav from "../features/components/FeaturesNav";
import Footer from "../home/components/Footer";
import BackToTopButton from "../../components/feature/BackToTopButton";

export default function Pricing() {
  const [billingCycle, setBillingCycle] = useState<"monthly" | "annual">("monthly");

  return (
    <div className="min-h-screen bg-[#0A1628]">
      <FeaturesNav />
      <PricingHero billingCycle={billingCycle} setBillingCycle={setBillingCycle} />
      <PricingCards billingCycle={billingCycle} />
      <PricingComparison />
      <PricingFAQ />
      <PricingCTA />
      <Footer />
      <BackToTopButton />
    </div>
  );
}
